exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-html-p p{\n\tmargin: 0px !important;\n}\n", ""]);

// exports
